import { TLanguageIDs, TAvailableCountries } from 'types';

export const trueOrderLanguageIDs: TLanguageIDs[] = [
	'475717ea-2f6f-4545-a0b0-98bbc483564e',
	'2d95f7a5-7a8d-4e3d-bb59-769f3f95970d',
	'58d0e8c7-a20d-40e1-a4d6-fd701a913eff',
	'973e4eb6-6e29-49ee-8455-d29613d30d2d',
	'9bb106f2-ad52-4a57-a0c1-7b5ced1f55f5',
	'75b14f56-cd51-4b1b-98c0-01effbd5cefc',
	'7e9ada27-9886-4838-b8b0-6ba39f5faa5d',
	'6f2e7f3f-7fa9-47d2-8289-9f4dd8b84060',
	'503bc1c9-4fba-4525-bcd2-d78196eefc15',
	'79d69d6c-9192-44f1-ad68-92939536a7b7',
	'7463d99a-2f70-423f-972b-707338c8945a',
	'7ae26617-a564-47ed-8722-5545151999d8',
	'd7f7b7c9-78f8-4ab5-bc9d-cc6eb7cf7831',
	'7a6ae23b-56c0-4b14-b7fe-7be35707e658',
	'a07a15bb-9d7b-4be4-9f61-2a32dba9a24f',
	'a39f8dca-64a2-4902-88f7-7673addd79ac',
	'd42f5c1a-5509-458d-9126-3961e24b1797',
	'15a9d0fb-25b7-4976-9430-a1d1ef501a29',
	'ec893fbc-e53a-498c-a67f-716149f66a28',
	'0e3734e1-06db-423d-acd4-7b755f079d63',
	'a2b9b0df-7294-4200-b09d-c224999ab7d3',
	'4ef4e46b-3bdc-44e0-ab74-ff6705818e3e',
	'c47fb2aa-a1ab-4ed6-8195-16b8117740bb',
	'b1b3097d-330a-48a1-8ad5-ab245dfb7df7',
	'9574bb62-4914-4867-a4e7-6019232fd611',
	'6c67e2f5-7183-4511-acd2-2952ce1c4026',
	'9d749652-b046-4b54-97a9-98897c054f13',
];

export const availableCountries: TAvailableCountries = {
	'58d0e8c7-a20d-40e1-a4d6-fd701a913eff': {
		countryCode: 'UA',
		languageName: 'Український',
	},
	'2d95f7a5-7a8d-4e3d-bb59-769f3f95970d': {
		countryCode: 'RU',
		languageName: 'Русский',
	},
	'475717ea-2f6f-4545-a0b0-98bbc483564e': {
		countryCode: 'GB',
		languageName: 'English',
	},
	'973e4eb6-6e29-49ee-8455-d29613d30d2d': {
		countryCode: 'DE',
		languageName: 'German',
	},
	'9bb106f2-ad52-4a57-a0c1-7b5ced1f55f5': {
		countryCode: 'CN',
		languageName: 'Chinese',
	},
	'75b14f56-cd51-4b1b-98c0-01effbd5cefc': {
		countryCode: 'FR',
		languageName: 'French',
	},
	'7e9ada27-9886-4838-b8b0-6ba39f5faa5d': {
		countryCode: 'IT',
		languageName: 'Italian',
	},
	'6f2e7f3f-7fa9-47d2-8289-9f4dd8b84060': {
		countryCode: 'PL',
		languageName: 'Polish',
	},
	'503bc1c9-4fba-4525-bcd2-d78196eefc15': {
		countryCode: 'ES',
		languageName: 'Spanish',
	},
	'79d69d6c-9192-44f1-ad68-92939536a7b7': {
		countryCode: 'SK',
		languageName: 'Slovenský',
	},
	'7463d99a-2f70-423f-972b-707338c8945a': {
		countryCode: 'DA',
		languageName: 'Danish',
	},
	'7ae26617-a564-47ed-8722-5545151999d8': {
		countryCode: 'BG',
		languageName: 'Bulgarian',
	},
	'd7f7b7c9-78f8-4ab5-bc9d-cc6eb7cf7831': {
		countryCode: 'RO',
		languageName: 'Romanian',
	},
	'7a6ae23b-56c0-4b14-b7fe-7be35707e658': {
		countryCode: 'HR',
		languageName: 'Croatian',
	},
	'a07a15bb-9d7b-4be4-9f61-2a32dba9a24f': {
		countryCode: 'CS',
		languageName: 'Czech',
	},
	'a39f8dca-64a2-4902-88f7-7673addd79ac': {
		countryCode: 'NL',
		languageName: 'Dutch',
	},
	'd42f5c1a-5509-458d-9126-3961e24b1797': {
		countryCode: 'ET',
		languageName: 'Estonian',
	},
	'15a9d0fb-25b7-4976-9430-a1d1ef501a29': {
		countryCode: 'FI',
		languageName: 'Finnish',
	},
	'ec893fbc-e53a-498c-a67f-716149f66a28': {
		countryCode: 'EL',
		languageName: 'Greek',
	},
	'0e3734e1-06db-423d-acd4-7b755f079d63': {
		countryCode: 'HU',
		languageName: 'Hungarian',
	},
	'a2b9b0df-7294-4200-b09d-c224999ab7d3': {
		countryCode: 'GA',
		languageName: 'Irish',
	},
	'4ef4e46b-3bdc-44e0-ab74-ff6705818e3e': {
		countryCode: 'LV',
		languageName: 'Latvian',
	},
	'c47fb2aa-a1ab-4ed6-8195-16b8117740bb': {
		countryCode: 'LT',
		languageName: 'Lithuanian',
	},
	'b1b3097d-330a-48a1-8ad5-ab245dfb7df7': {
		countryCode: 'MT',
		languageName: 'Maltese',
	},
	'9574bb62-4914-4867-a4e7-6019232fd611': {
		countryCode: 'PT',
		languageName: 'Portuguese',
	},
	'6c67e2f5-7183-4511-acd2-2952ce1c4026': {
		countryCode: 'SL',
		languageName: 'Slovenian',
	},
	'9d749652-b046-4b54-97a9-98897c054f13': {
		countryCode: 'SV',
		languageName: 'Swedish',
	},
};

export const NON_EXISTENT_KEY = 'NON_EXISTENT_KEY';
export const PRE_SELECTED_CUSTOMER_ID_FOR_MENU = 'PRE_SELECTED_CUSTOMER_ID_FOR_MENU';
export const SHOW_ARCHIVED_CUSTOMERS = 'SHOW_ARCHIVED_CUSTOMERS';
export const SHOW_ARCHIVED_RESTAURANTS = 'SHOW_ARCHIVED_RESTAURANTS';
export const ALLERGEN_SETTING_KEY = 'allergen_setting';
export const TERMS_SETTING_KEY = 'terms_setting';
export const M4_SOFT_POS_QR_BANK_SETTINGS_ID = '2dec985a-9fab-4162-9a0e-b8d9a06e9534';
export const NEW_BANK_SETTINGS_BLOCK_PREFIX = 'newBankSettingsBlock';
export const NEW_NFC_CARDS_BLOCK_PREFIX = 'newNfcCardsBlock';
